<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0">
      <div class="actions-left col-lg-6 row p-0 m-0">
       <span class="col-lg-6 m-0 p-0 text-left"> 
         <button v-bind:class="{'font-weight-bold': isVisible}" class="is-visible-button" @click="isVisible = true">{{ $t('active') }}</button> <span  v-bind:class="{'font-weight-bold': isVisible}">({{activeCount}})</span> | <button v-bind:class="{'font-weight-bold': !isVisible}" class="is-visible-button" href="#" @click="isVisible = false">{{ $t('disabled') }}</button> <span v-bind:class="{'font-weight-bold': !isVisible}">({{disabledCount}})</span>
       </span>
      </div>
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary mr-2" @click="manageCategories">{{ $t('manageCategories') }}</button>
        <button type="button" class="btn btn-primary" @click="addProduct">{{ $t('addProduct') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="caption" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
    <!-- QR CODE -->
    <div class="qrcode" v-if="showModal">
      <h1 class="mb-5">{{$t("qrGenerated")}}</h1>
      <qrcode-vue id="mycanvas" :value="qrValue" :size="QR_SIZE" level="H" background="#ffffff" foreground="#000000"></qrcode-vue>
      <button type="button" class="btn btn-primary my-3" @click="downloadQr(value)">{{$t("download")}}</button>
      <button type="button" class="btn btn-primary" @click="showModal = false">{{$t("close")}}</button>
    </div>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from '@/views/controls/PaginatedTable.vue'
import SearchBar from '@/views/controls/SearchBar.vue'
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase } from "@/helpers/utils.js";
import QrcodeVue from 'qrcode.vue';

const CATEGORY_TYPE = "Product";
const QR_SIZE = 300;

export default {
  components: { CTableWrapper, SearchBar, QrcodeVue },
  data () {
    return {
      isVisible: null,
      searchText: '',
      caption: i18n.t('products'),
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'title', label: i18n.t('name'), _classes: 'font-weight-bold', sortable: true },
        { key: 'categoryNames', label: i18n.t('categories'), sorter: false},
        { key: 'price', label: i18n.t('price'), sortable: true },
      ],
      actions: [],
      sorterValue: { column: 'id', asc: false },
      loading: false,
      false: false,
      true: true,
      showModal: false,
      // Provide access to consts on HTML
      QR_SIZE: QR_SIZE
    }
  },
  computed: {
    ...mapState('products', ['listOutput']),
    ...mapState('products', ['processTask']),
    productsInfo: function() {
      return this.listOutput ? this.listOutput : null;
    },
    items: function()
    {
      var result = [];

      if(this.productsInfo && this.productsInfo.data)
      {
        result = this.productsInfo.data;
        result.forEach(product => {
          product.categoryNames = product.categories.map(x=> x.name).join(", ");
        });
      }

      return result;
    },
    pages: function()
    {
      return this.productsInfo ? this.productsInfo.totalPages : 1;
    },
    activeCount: function()
    {
      return this.productsInfo ? this.productsInfo.visible : 0;
    },
    disabledCount: function()
    {
      return this.productsInfo ? this.productsInfo.notVisible : 0
    },
  },
  mounted: function()
  {
    this.isVisible = true; //this.updateItemsRequested(1, this.itemsPerPage);
  },
  methods: {
    downloadQr (value) 
    {
      let canvasImages =document.getElementsByTagName('canvas');
      let canvasImage =canvasImages[0].toDataURL('image/png');

      // this can be used to download any image from webpage to local disk
      let xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function () {
        let a = document.createElement('a');
        a.href = window.URL.createObjectURL(xhr.response);
        a.download = value+'.jpg';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove()
      };
      xhr.open('GET', canvasImage); // This is to download the canvas Image
      xhr.send();
      this.showModal = false;
    },
    ...mapActions('products', ['getList']),
    ...mapActions('products', ['updateStatus']),
    rowClicked (item, index) {
      this.$router.push({name: "EditProduct", params: { product: item } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'qrcode':
        {
          this.qrValue = `${process.env.VUE_APP_WEB_PRODUCT_ROOT}?id=${item.id}`;
          this.showModal = true;
          break;
        }
        case 'view':
        {
          this.$router.push({name: "EditProduct", params: { product: item } });
          break;
        }
        case 'disable':
        {
          if(confirm(this.$i18n.tc('confirmDisable', item.title, { name: item.title }))){
            this.updateStatus(item.id);
          }
          break;
        }
        case 'enable':
        {
          if(confirm(this.$i18n.tc('confirmEnable', item.title, { name: item.title }))){
            this.updateStatus(item.id);
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));
      // List specific parameters
      input.visible = this.isVisible;
      this.getList(input); 
    },
    addProduct () 
    {
      router.push({ path: '/products/add' });
    },
    manageCategories()
    {
      this.$router.push({name: "ListCategories", params: { type: CATEGORY_TYPE } });
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }    
  },
  watch:
  {
    isVisible: function (val) {
      // Update actions
      switch(val) {

        case true:
        {
          this.actions = [];        
          this.actions.push({ key: 'view', label: this.$i18n.t("view") });
          this.actions.push({ key: 'disable', label: this.$i18n.t("disable") });
          this.actions.push({ key: 'qrcode', label: this.$i18n.t("qrcode") });
          
          break;
        }
        case false:
        {
          this.actions = [];
        
          this.actions.push({ key: 'view', label: this.$i18n.t("view") });
          this.actions.push({ key: 'enable', label: this.$i18n.t("enable") });
          this.actions.push({ key: 'qrcode', label: this.$i18n.t("qrcode") });

          break;
        }
        default:
        {
          throw "The provided isVisible is not supported!"; 
        }
      }

      // Update items
      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    processTask: function(val)
    {
      this.loading = true;

      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    listOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.is-visible-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}

.qrcode
{
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;        
}

.qrcode > h1 
{
  color: #fff;
}
</style> 